import { render } from "./Menores.vue?vue&type=template&id=8a5f009e&ts=true"
import script from "./Menores.vue?vue&type=script&lang=ts"
export * from "./Menores.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__